module.exports = __webpack_public_path__ + "static/media/restaurant_illustration.31c1f73a.png";